export function OrderSummaryMobileSkeleton({
  itemsCount = 1
}: { itemsCount?: number } = {}) {
  const items = Array.from({ length: itemsCount }, (_, i) => i + 1);

  return (
    <div className="mb-4 sm:hidden">
      {/* Accordion Structure without the card wrapper */}
      <div className="overflow-hidden rounded-lg border border-gray-200 bg-white">
        <div className="gap-2 px-4 py-4">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-2">
              <div
                className="loading-shimmer h-4 w-24 rounded bg-gray-200"
                style={{ animationDelay: "0ms" }}
              />
            </div>
            <div
              className="loading-shimmer h-4 w-4 shrink-0 rounded bg-gray-200"
              style={{ animationDelay: "50ms" }}
            />
            <div className="ms-auto flex items-center gap-1">
              <div
                className="loading-shimmer h-4 w-16 rounded bg-gray-200"
                style={{ animationDelay: "100ms" }}
              />
              <div
                className="loading-shimmer h-4 w-4 rounded bg-gray-200"
                style={{ animationDelay: "125ms" }}
              />
            </div>
          </div>
        </div>

        {/* Accordion Content */}
        <div className="px-4 pb-4">
          <div className="mt-2 space-y-4">
            {/* Cart Items Skeleton */}
            <div className="space-y-3">
              {items.map((i) => (
                <div
                  key={i}
                  className={`flex gap-3 ${i < itemsCount ? "border-b border-gray-100 pb-3" : ""}`}
                >
                  <div className="relative w-10 shrink-0">
                    <div
                      className="loading-shimmer aspect-square h-full w-full rounded border border-gray-300 bg-gray-200"
                      style={{ animationDelay: `${150 + i * 50}ms` }}
                    />
                    <div
                      className="loading-shimmer absolute -right-1 -top-1 z-10 size-4 rounded-full bg-gray-300"
                      style={{ animationDelay: `${175 + i * 50}ms` }}
                    />
                  </div>
                  <div className="min-w-0 flex-1">
                    <div className="flex items-start justify-between gap-2">
                      <div
                        className="loading-shimmer h-4 w-32 rounded bg-gray-200"
                        style={{ animationDelay: `${200 + i * 50}ms` }}
                      />
                      <div className="flex shrink-0 items-center gap-1">
                        <div
                          className="loading-shimmer h-4 w-12 rounded bg-gray-200"
                          style={{ animationDelay: `${225 + i * 50}ms` }}
                        />
                        <div
                          className="loading-shimmer h-3 w-3 rounded bg-gray-200"
                          style={{ animationDelay: `${250 + i * 50}ms` }}
                        />
                      </div>
                    </div>
                    <div
                      className="loading-shimmer mt-0.5 h-3 w-20 rounded bg-gray-200"
                      style={{ animationDelay: `${275 + i * 50}ms` }}
                    />
                  </div>
                </div>
              ))}
            </div>

            {/* Coupon Section Skeleton */}
            <div className="pt-1">
              <div
                className="loading-shimmer h-10 w-full rounded bg-gray-200"
                style={{ animationDelay: `${itemsCount * 50 + 325}ms` }}
              />
            </div>

            {/* Order Breakdown Skeleton - exact structure match */}
            <div className="space-y-2 border-t border-gray-100 pt-3">
              {/* Subtotal */}
              <div className="flex justify-between text-sm">
                <div
                  className="loading-shimmer h-4 w-16 rounded bg-gray-200"
                  style={{ animationDelay: `${itemsCount * 50 + 350}ms` }}
                />
                <div className="flex items-center gap-1">
                  <div
                    className="loading-shimmer h-4 w-12 rounded bg-gray-200"
                    style={{ animationDelay: `${itemsCount * 50 + 375}ms` }}
                  />
                  <div
                    className="loading-shimmer h-3 w-3 rounded bg-gray-200"
                    style={{ animationDelay: `${itemsCount * 50 + 400}ms` }}
                  />
                </div>
              </div>

              {/* Tax */}
              <div className="flex justify-between text-sm">
                <div
                  className="loading-shimmer h-4 w-6 rounded bg-gray-200"
                  style={{ animationDelay: `${itemsCount * 50 + 425}ms` }}
                />
                <div className="flex items-center gap-1">
                  <div
                    className="loading-shimmer h-4 w-10 rounded bg-gray-200"
                    style={{ animationDelay: `${itemsCount * 50 + 450}ms` }}
                  />
                  <div
                    className="loading-shimmer h-3 w-3 rounded bg-gray-200"
                    style={{ animationDelay: `${itemsCount * 50 + 475}ms` }}
                  />
                </div>
              </div>

              {/* Total */}
              <div className="flex justify-between border-t border-gray-200 pt-3">
                <div
                  className="loading-shimmer h-5 w-10 rounded bg-gray-200"
                  style={{ animationDelay: `${itemsCount * 50 + 500}ms` }}
                />
                <div className="flex items-center gap-1">
                  <div
                    className="loading-shimmer h-5 w-16 rounded bg-gray-200"
                    style={{ animationDelay: `${itemsCount * 50 + 525}ms` }}
                  />
                  <div
                    className="loading-shimmer h-4 w-4 rounded bg-gray-200"
                    style={{ animationDelay: `${itemsCount * 50 + 550}ms` }}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
